module.exports = __webpack_public_path__ + "img/help-video-bg.aa958d1.jpg";